import { Node, mergeAttributes } from '@tiptap/core';

// ═══════════════════════════════════════════════════════════════
// PageBreak — konec stránky (sekce 2.3 Stránky).
//
// V editoru se zobrazí jako viditelná přerušovaná čára s popiskem, v
// exportu se přeloží na skutečné zalomení stránky (w:br w:type="page").
// ═══════════════════════════════════════════════════════════════

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    pageBreak: {
      setPageBreak: () => ReturnType;
    };
  }
}

export const PageBreak = Node.create({
  name: 'pageBreak',
  group: 'block',
  atom: true,
  selectable: true,

  parseHTML() {
    return [
      { tag: 'div[data-page-break]' },
      // Word páruje zalomení stránky přes <br style="page-break-before">
      { tag: 'br.page-break' },
    ];
  },

  renderHTML() {
    return [
      'div',
      mergeAttributes({ 'data-page-break': 'true', class: 'doc-page-break', contenteditable: 'false' }),
      ['span', { class: 'doc-page-break-label' }, 'Konec stránky'],
    ];
  },

  addCommands() {
    return {
      setPageBreak:
        () =>
        ({ chain }) =>
          chain().insertContent({ type: this.name }).run(),
    };
  },
});
